import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  adName: {
    lineBreak: 'anywhere'
  }
})

export default useStyles
